import type { LoadingLifecycle } from './types';

export type SetPending = <T>() => LoadingLifecycle<T>;
export const setPending: SetPending = () => ({
  pending: true,
  fulfilled: undefined,
  rejected: undefined,
});
